import {h, Component} from 'preact';
import { CheckboxWithLabel } from '@webapp/preact-shared';
import CloseButtonWithCircle from '../tags/close-button-with-circle';
import OnPasswordUpdated from '../tags/on-password-updated';
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';

export default class PasswordChanged extends Component {
    constructor() {
        super();
        this.state = {
            isGuest: false,
            showPassword: false
        }
    }

    componentDidMount() {
        this.setState({
            isGuest: sessionStorage.getItem(SessionStorageKeys.guestAccess) === 'true'
        })
    }

    goToLogin = () => {
        this.props.goToPage('/');
    };

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    render({getPassword}, {isGuest, showPassword}) {
        return(
            <div className='form'>
                <h2>Password updated <CloseButtonWithCircle action={this.goToLogin}/></h2>
                {isGuest ? (
                    <div className='on-password-updated'>
                        <h4 className='success-message d-flex align-items-center'>
                            <i className="wi wi-check" /><span>Your password has been updated successfully.</span>
                        </h4>
                        <h4 className='mb-3'>You may now sign in to your account with your new password.</h4>
                        <div className='password-field-wrapper d-flex align-items-center'>
                            <input type={showPassword ? 'text' : 'password'}
                                   className='form-control'
                                   value={getPassword()}
                                   readOnly
                            />
                            <CheckboxWithLabel label='Show password' checked={showPassword} action={this.toggleShowPassword}/>
                        </div>
                    </div>
                ) : (
                    <OnPasswordUpdated getPassword={getPassword} />
                )}
                <div className='bottom-buttons clearfix'>
                    <a className='button button-prime pull-right' onClick={this.goToLogin}>Continue</a>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/reset-password/password-changed.js